import axios from 'axios';

const options = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

export const listNetworkAds = async () => (
  await axios.get('/api/admin/network-ads', options())
).data;

export const discoverNetworkAdCampaigns = async () => (
  await axios.get('/api/admin/network-ads/discovery/campaigns', options())
).data;

export const discoverNetworkAdTargets = async () => (
  await axios.get('/api/admin/network-ads/discovery/targets', options())
).data;

export const getNetworkAdsReport = async (filters = {}) => (
  await axios.get('/api/admin/network-ads/report', { ...options(), params: filters })
).data;

export const getNetworkAdsWorkspace = async () => (
  await axios.get('/api/admin/network-ads/workspace', options())
).data;

export const createNetworkAd = async (input) => (
  await axios.post('/api/admin/network-ads', input, options())
).data;

export const updateNetworkAd = async (id, input) => (
  await axios.put(`/api/admin/network-ads/${id}`, input, options())
).data;

export const pauseNetworkAd = async (id) => (
  await axios.post(`/api/admin/network-ads/${id}/pause`, {}, options())
).data;

export const archiveNetworkAd = async (id) => (
  await axios.post(`/api/admin/network-ads/${id}/archive`, {}, options())
).data;

export const createNetworkAdAssignment = async (networkAdId, input) => (
  await axios.post(`/api/admin/network-ads/${networkAdId}/assignments`, input, options())
).data;

export const updateNetworkAdAssignment = async (assignmentId, input) => (
  await axios.put(`/api/admin/network-ads/assignments/${assignmentId}`, input, options())
).data;

export const removeNetworkAdAssignment = async (assignmentId) => (
  await axios.delete(`/api/admin/network-ads/assignments/${assignmentId}`, options())
).data;

export const getNetworkAdsRollout = async () => (
  await axios.get('/api/admin/platform-settings/network-ads-rollout', options())
).data;

export const updateNetworkAdsRollout = async (enabled) => (
  await axios.put('/api/admin/platform-settings/network-ads-rollout', { enabled }, options())
).data;

export const updateNetworkAdsSiteRollout = async (siteId, disabled) => (
  await axios.put(
    `/api/admin/platform-settings/network-ads-rollout/sites/${siteId}`,
    { disabled },
    options()
  )
).data;
